import React from "react"
import { Container } from "react-bootstrap"

import Layout from "../components/layout"
import SEO from "../components/seo"
import CompoundChurnImpact from "../components/compoundChurnImpact"
import EmailCapture from "../components/emailCapture"

import { config } from "@fortawesome/fontawesome-svg-core"
import "@fortawesome/fontawesome-svg-core/styles.css"
config.autoAddCss = false

const IndexPage = () => (
  <Layout>
    <SEO title="Compound effect of churn" keywords={[`calculator`, `churn`, `compound churn`]} />
    <Container>
      <CompoundChurnImpact />
      <EmailCapture />
    </Container>
  </Layout>
)

export default IndexPage
